<!--
File: product-form.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Friday, 18th October 2024 10:32:11 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<p-sidebar>
  <p-header>
    <div class="header">
      <h3>{{ entity.name }}</h3>
    </div>
  </p-header>
  <div>
    <p-listbox
      [options]="entity.versions"
      [(ngModel)]="currentVersion"
      [optionLabel]="currentVersion.name"
      [style]="{ width: '100%' }"></p-listbox>
  </div>
  <p-footer>
    
  </p-footer>
</p-sidebar>
<!-- <mat-drawer-container>
  <mat-drawer mode="side" opened>
    <mat-list>
      <mat-list-item
        class="version-list"
        *ngFor="let version of entity.versions; let i = index"
        ><div mat-line class="label version">Version: {{ i + 1 }}</div>
        <div mat-line class="label date">
          Creada: {{ version.createdAt | date }}
        </div></mat-list-item
      >
    </mat-list>
  </mat-drawer>

  <div
    *ngIf="!loading"
    
    
    
    style="padding: 1em !important"
  >
   
    <div appearance="outline" class="full-witdth">
      <label>{{ "PRODUCT.SKU" | translate }} </label>
      <input matInput type="text" [(ngModel)]="currentVersion.sku" />
    </div>
    <div appearance="outline" class="full-witdth">
      <label>{{ "NAME" | translate }} </label>
      <input matInput type="text" [(ngModel)]="currentVersion.name" />
    </div>
    <div appearance="outline" class="full-witdth">
      <label>{{ "DESCRIPTION" | translate }} </label>
      <input matInput type="text" [(ngModel)]="currentVersion.description" />
    </div>

    <div
      appearance="outline"
      class="full-witdth"
      *ngFor="let extra of currentVersion.extra; let i = index"
    >
      <label>{{ extra.label }}</label>
      <input matInput type="text" [(ngModel)]="currentVersion.extra[i].value" />
    </div>
  </div>
</mat-drawer-container> -->
